export const STATUS_ID_TO_KEY = {
  1: "active",
  2: "inactive",
  3: "prospect",
  4: "draft",
};

export const cityOptions = [
  { label: "Islamabad", value: "islamabad" },
  { label: "Rawalpindi", value: "rawalpindi" },
  { label: "Lahore", value: "lahore" },
  { label: "Karachi", value: "karachi" },
  { label: "Faisalabad", value: "faisalabad" },
  { label: "Multan", value: "multan" },
  { label: "Peshawar", value: "peshawar" },
  { label: "Sialkot", value: "sialkot" },
];

export const statusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const locationStatusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const resolveWarehouseStatus = (status) => {
  if (status === null || status === undefined || status === "") return "";
  if (typeof status === "boolean") return status ? "active" : "inactive";
  const normalized = String(status).trim().toLowerCase();
  if (normalized === "1" || normalized === "active" || normalized === "true") return "active";
  if (normalized === "2" || normalized === "inactive" || normalized === "false" || normalized === "0") return "inactive";
  return normalized;
};

export const statusFilterOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const goodsTypeOptions = [
  { label: "Light", value: 1 },
  { label: "Heavy", value: 2 },
  { label: "Trailers", value: 3 },
];

export const industryTypeOptions = [
  { label: "Spare Parts", value: "spare_parts" },
  { label: "Hardware", value: "hardware" },
  { label: "Retail", value: "retail" },
  { label: "Food", value: "food" },
  { label: "Electronics", value: "electronics" },
  { label: "Logistics", value: "logistics" },
  { label: "Courier", value: "courier" },
  { label: "Fuel Transport", value: "fuel_transport" },
  { label: "Chemical Transport", value: "chemical_transport" },
  { label: "Gas Transport", value: "gas_transport" },
  { label: "Cold Chain", value: "cold_chain" },
  { label: "Heavy Transport", value: "heavy_transport" },
  { label: "Vehicle Rental", value: "vehicle_rental" },
  { label: "Warehousing", value: "warehousing" },
  { label: "Beverages", value: "beverages" },
];

export const designationOptions = [
  { label: "Operation Manager", value: "operation_manager" },
  { label: "Dispatch Supervisor", value: "dispatch_supervisor" },
  { label: "Sales Coordinator", value: "sales_coordinator" },
];

export const billingFrequencyOptions = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
];

export const paymentMethodOptions = [
  { label: "Bank Transfer", value: "bank_transfer" },
  { label: "Cash", value: "cash" },
];

export const paymentTermOptions = [
  { label: "Net 15", value: "net_15" },
  { label: "Net 30", value: "net_30" },
  { label: "Immediate", value: "immediate" },
];

export const productTypeOptions = [
  { label: "Liquid/Chemical", value: "Liquid/Chemical" },
  { label: "Solid", value: "Solid" },
  { label: "Fragile", value: "Fragile" },
  { label: "Machinery", value: "Machinery" },
  { label: "Electronics", value: "Electronics" },
  { label: "General", value: "General" },
];

export const insuranceCoverTypeOptions = [
  { label: "Comprehensive", value: "Comprehensive" },
  { label: "Partial", value: "Partial" },
  { label: "Third Party", value: "Third Party" },
];

export const insuranceStatusOptions = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
  { label: "Expired", value: "Expired" },
  { label: "Pending", value: "Pending" },
];

export const fallbackBankOptions = [
  { label: "AL-HABIB BANK", value: "al_habib_bank" },
  { label: "HBL", value: "hbl" },
  { label: "UBL", value: "ubl" },
];

export const stepItems = [
  { title: "General Details" },
  { title: "Point of Contact" },
  { title: "Location Info" },
  { title: "Products" },
  { title: "Attachments" },
  { title: "Payment Mode" },
];
